
/* @ngInject */
export default class SingleSignOnService {
    constructor(HPConfig, $http, $q) {
        this.HPConfig = HPConfig;
        this.$http = $http;
        this.$q = $q;
    }

    getAuthorization() {
        const def = this.$q.defer();

        const url = `${this.HPConfig.heroProApi}SingleSignOn/GetAccessToken`;
        this.$http.post(url).then((resp) => {
            def.resolve(resp.Data || resp.data);
        });

        return def.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/common/angular/singleSignOnFactory.js